module.exports = __webpack_public_path__ + "static/img/logo.b9bae22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gameinviteRoom/assets/logo.png
// module id = mVP2
// module chunks = 23